import React from 'react';
// @ts-ignore
import post from './assets/promotion-post.webp';
import CloseIcon from './close';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';
import {downloadApk} from '@utils';

export default function PromotionModal() {
  const {goToNext} = useSequentialModalContext();
  return (
    <div>
      <div
        className="w-80 h-[29.5rem] bg-full"
        style={{backgroundImage: `url(${post})`}}
        onClick={() => {
          downloadApk();
          goToNext();
        }}></div>
      <div className="flex items-center justify-center mt-6">
        <div className="border border-white rounded-full flex items-center justify-center size-8">
          <CloseIcon onClick={goToNext} class="size-2.5" />
        </div>
      </div>
    </div>
  );
}
